import * as React from 'react'
import styled from 'styled-components'

import {
  Box,
  get,
  Space,
  SteppedProcess,
  TextHeading,
} from '@ally/metronome-ui'
import { AllyUserRole } from '@ally/transmitigator'

import { getDisplayRole } from '../../Utils'

const StyledBox = styled(Box)`
  border-left: 1px solid ${get.colors('slate-2')};
  padding-left: ${get.space('md')};
  margin-top: ${get.space('xl')};

  h3 {
    font-size: ${get.fontSizes('lg')};
  }
`

interface InitialState {
  activeStepIndex?: number
  completedStepIndices?: number[]
}

export enum AccountLinkingScreen {
  BankToAuto,
  AutoToBank,
  LinkingSuccess,
}

export const getInitialStateForScreen = (
  screen: AccountLinkingScreen,
): InitialState => {
  let initialState = {}

  switch (screen) {
    case AccountLinkingScreen.BankToAuto:
      initialState = {
        activeStepIndex: 0,
      }
      break
    case AccountLinkingScreen.AutoToBank:
      initialState = {
        activeStepIndex: 1,
        completedStepIndices: [0],
      }
      break
    case AccountLinkingScreen.LinkingSuccess:
      initialState = {
        activeStepIndex: 2,
        completedStepIndices: [0, 1],
      }
      break
    default:
    // No-op
  }

  return initialState
}

interface AccountLinkingStepperProps {
  userRelationships: AllyUserRole
  screen: AccountLinkingScreen
}

// @ally/metronome-ui does not export this type, but complains if we just set the headingLevel to a 'string'
type HeadingTypes = 'h2' | 'h3' | 'h4' | 'h5'

export const AccountLinkingStepper: React.FC<AccountLinkingStepperProps> = ({
  userRelationships,
  screen,
}) => {
  const steps = [
    {
      id: 'enter-enterprise-password',
      title: {
        headingLevel: 'h3' as HeadingTypes,
        text: `Enter your ${getDisplayRole(userRelationships)} password`,
      },
      content: <></>,
      summary: {
        items: [],
        editStepButton: { isHidden: true },
      },
    },
    {
      id: 'enter-auto-password',
      title: {
        headingLevel: 'h3' as HeadingTypes,
        text: 'Enter your Auto password',
      },
      content: <></>,
      summary: {
        items: [],
        editStepButton: { isHidden: true },
      },
    },
    {
      id: 'summary',
      title: {
        headingLevel: 'h3' as HeadingTypes,
        text: 'Access all of your accounts with one username',
      },
      content: <></>,
      summary: {
        items: [],
        editStepButton: { isHidden: true },
      },
    },
  ]

  const a11y = { ariaLabelSection: 'TODO' } // TODO what should this be?

  return (
    <StyledBox>
      <Space mb="md">
        <TextHeading tag="h2" size="sm">
          Connect your Ally accounts.
        </TextHeading>
      </Space>
      <SteppedProcess
        a11y={a11y}
        initialState={getInitialStateForScreen(screen)}
        steps={steps}
        variant="vertical"
      />
    </StyledBox>
  )
}
